<template>
  <div id="worksList">
    <ul>
      <li v-for="post in data" :key="post.id">
        <span class="img">
          <a :href="post.link" target="_blank">
            <img v-if="post.thumb" :src="post.thumb.url" :alt="post.title" />
            <img v-else src="../../img/works/img_02.png" :alt="post.title" />
          </a> </span
        ><span class="txt">{{ post.title }}</span>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: "Works",
  data: function() {
    return {
      data: {}
    };
  },
  mounted() {
    this.getWorks();
  },
  methods: {
    getWorks() {
      this.$axios
        .get("https://doode.microcms.io/api/v1/works?limit=50", { headers: { "X-API-KEY": "a63e0cd1-8536-4cb2-a06d-aabe46e4ba6d" } })
        .then(response => {
          this.data = response.data.contents;
        })
        .catch(reason => {});
    }
  }
};
</script>
